<template>
    <div class="card mb-25 border-0 rounded-0 bg-white create-role-box">
      <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
        <form @submit.prevent="addQwilrIntegration">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Account Id
                </label>
                <input
                    class="form-control"
                    v-model="accountId"
                    rows="4"/>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">
                  Access Token
                </label>
                <textarea
                    class="form-control"
                    v-model="accessToken"
                    rows="4"></textarea>
              </div>
            </div>
            <div class="col-md-12">
              <button
                class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                type="submit"
              >
                Save
              </button>

              <button @click="goToMainMenu" class="default-btn transition border-0 fw-medium text-white 
                pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 
                fs-md-15 fs-lg-16 m-5 bg-danger" type="button"> Cancel </button>
                </div>
          </div>
        </form>
      </div>
    </div>
  </template>
  
  <script lang="ts">
  import { defineComponent, ref } from "vue";
  import HSuiteApiService from "@/core/services/hsuiteApi.service";
  import { useRouter } from "vue-router";
  import { useToast } from 'vue-toastification'
  
  export default defineComponent({
    name: "QwilrForm",
    setup() {
      const accessToken = ref("");

      const accountId = ref("");

      const router = useRouter();
  
      const goToMainMenu = async () => {
        router.push({ name: "IntegrationListPage" });
      };
  
      const addQwilrIntegration = async () => {
        const toast = useToast();
        const payload = { accessToken: accessToken.value, accountId: accountId.value };
        
        HSuiteApiService.post(`/api/Integration/AddQwilrIntegration`, payload)
                  .then(response => {
                  if (response.status === 200) {
                    toast.success('Qwilr integration processed successfully!', {
                      timeout: 2000
                    })
                    goToMainMenu();
                  }
                  })
                  .catch(ex => {
                    const errorMessage = ex.response?.data || ex.message || "An unknown error occurred";
                    console.log(ex);
                    toast.error(`Failed to integrate qwilr : ${errorMessage}`, {timeout: 2000,});
                  })

      };
  
      return {
        accessToken,
        addQwilrIntegration,
        goToMainMenu,
        accountId
      };
    },
  });
  </script>
  